__turbopack_context__.v({
  "blogBadge": "SimilarPostCard-module-scss-module__QTTSDW__blogBadge",
  "card": "SimilarPostCard-module-scss-module__QTTSDW__card",
  "categories": "SimilarPostCard-module-scss-module__QTTSDW__categories",
  "categoryTag": "SimilarPostCard-module-scss-module__QTTSDW__categoryTag",
  "content": "SimilarPostCard-module-scss-module__QTTSDW__content",
  "date": "SimilarPostCard-module-scss-module__QTTSDW__date",
  "excerpt": "SimilarPostCard-module-scss-module__QTTSDW__excerpt",
  "image": "SimilarPostCard-module-scss-module__QTTSDW__image",
  "imageWrapper": "SimilarPostCard-module-scss-module__QTTSDW__imageWrapper",
  "title": "SimilarPostCard-module-scss-module__QTTSDW__title",
});
